import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { StatusMessage, SoffNotifier } from '@soff/shared-ui';
import { NotificationActions } from './shared/state/notification';

/** SOFF adapter for `SoffNotifier`: routes messages through the root store (`ShowSnackbar`). */
@Injectable()
export class StoreSoffNotifier implements SoffNotifier {
  private store = inject(Store);

  notify(message: StatusMessage): void {
    this.store.dispatch(new NotificationActions.ShowSnackbar(message));
  }
}
